import { QueryClient } from '@tanstack/react-query'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Default stale time of 5 minutes
      staleTime: 5 * 60 * 1000,
      // Default cache time of 10 minutes
      gcTime: 10 * 60 * 1000,
      // Retry failed requests 3 times
      retry: 3,
      // Exponential backoff for retries
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
      // Refetch on window focus
      refetchOnWindowFocus: true,
    },
    mutations: {
      // Retry failed mutations twice
      retry: 2,
    },
  },
})

// Global error handler
queryClient.setDefaultOptions({
  queries: {
    queryFn: async ({ queryKey, signal }) => {
      try {
        const response = await fetch(queryKey[0] as string, { signal })
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`)
        }
        return response.json()
      } catch (error) {
        console.error('Query error:', error)
        throw error
      }
    },
  },
})

export default queryClient
